module.exports = __webpack_public_path__ + "static/img/culture3.6898617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/culture3.png
// module id = M0Zs
// module chunks = 1